export const isPlanCheckFailed = (error: any) =>
  Boolean(error?.body?.data?.plan_limits_reached);

export const isMarketingHubRequired = (error: any) =>
  Boolean(error?.body?.data?.marketing_hub_required);
